import {
  FeatureName,
  useCurrentWorkspace,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { SlideAction, useSlideLayout } from '@gripp/shared-ui';
import { useWorkspaceAsset } from 'libs/shared-logic/src/assets/hooks/useWorkspaceAsset';
import { Icon } from 'libs/shared-ui/src/components/crop-circle/icons/Icon';
import { Pressable, StyleSheet, View } from 'react-native';
import { useLocation, useNavigate, useParams } from 'react-router';
import { AddButton } from '../../shared/components/addButton/addButton';
import { useAssetRouting } from '../assetRouteContext';
import { isActivityOrEditPage } from '../assetUtils';
import { AssetFiltersOld } from './assetFilters-old';

export const AssetFilters = ({
  assetId,
  issueId,
}: {
  assetId: string;
  issueId?: string;
}) => {
  // TODO: Crop Circle Redesign: Remove after feature is fully rolled out
  const isCropCircleEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );
  const { workspaceAsset } = useWorkspaceAsset(assetId, !assetId);
  const workspaceId = workspaceAsset?.workspace?.id ?? '';

  if (!assetId) {
    return null;
  }

  // TODO: Crop Circle Redesign: Remove after feature is fully rolled out
  if (!isCropCircleEnabled) {
    return <AssetFiltersOld assetId={assetId} workspaceId={workspaceId} />;
  }

  // TODO: Crop Circle Redesign: Remove to AssetFiltersBase after feature is fully rolled out
  return <AssetFiltersBase assetId={assetId} issueId={issueId} />;
};

export const AssetFiltersBase = ({
  assetId,
  issueId: issueIdProp,
}: {
  assetId: string;
  issueId?: string;
}) => {
  const { onSlideChange } = useSlideLayout();
  const location = useLocation();
  const navigate = useNavigate();
  const { basePath } = useAssetRouting(assetId);
  const workspace = useCurrentWorkspace();

  // issueId may come from props (ActivityConversationPanel passes it explicitly)
  // or from URL params (activity-context asset pages like /activities/:id/asset/:id/edit).
  const { issueId: routeIssueId } = useParams();
  const issueId = issueIdProp ?? routeIssueId;

  const onAssetEdit = async () => {
    // Skip NEXT on /assets/:id — edit is rendered inline so no transition.
    const isOnAssetDetail = /^\/assets\/[^/]+\/?$/.test(location.pathname);
    if (!isActivityOrEditPage(location) && !isOnAssetDetail) {
      await onSlideChange(SlideAction.NEXT);
    }

    // In activities context, use the activity-prefixed URL so back navigation
    // returns to the asset panel inside activities (/activities/:id/asset/:id).
    const editPath = issueId
      ? `/activities/${issueId}/asset/${assetId}/edit`
      : `${basePath}/edit`;
    navigate(editPath);
  };

  const onAddNewIssue = async () => {
    if (!isActivityOrEditPage(location)) {
      await onSlideChange(SlideAction.NEXT);
    }

    const newIssuePath = issueId
      ? `/activities/${issueId}/asset/${assetId}/activity/new`
      : `${basePath}/activity/new`;
    navigate(newIssuePath);
  };

  return (
    <View style={styles.filtersContainer}>
      <Pressable onPress={onAssetEdit} testID="asset-card-edit-button">
        <Icon name="Settings" size={24} />
      </Pressable>
      {workspace && <AddButton onPress={onAddNewIssue} />}
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 16,
  },
  modal: {
    alignSelf: 'center',
    backgroundColor: 'white',
    padding: 0,
    margin: 0,
    borderRadius: 10,
    width: 560,
    minHeight: 400,
  },
});
